<template>
  <span
    v-if="isActive"
    @click="$emit('itemAction')"
    class="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded border transition-colors duration-200"
    :class="[
      mode === 'dark' ? 'border-dark-border' : 'border-border-10',
      currentAction.classes,
    ]"
    v-tooltip="currentAction.tooltip"
  >
    <component :is="currentAction.icon" :size="17" :stroke-width="1.75" />
  </span>
  <span
    v-else
    class="flex h-[32px] w-[32px] cursor-not-allowed items-center justify-center rounded border opacity-50"
    :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
    v-tooltip="'Not allowed'"
  >
    <component :is="currentAction.icon" :size="17" :stroke-width="1.75" />
  </span>
</template>

<script>
import { Trash2, Pencil, Eye } from "lucide-vue-next";

export default {
  name: "TableAction",
  props: {
    mode: String,
    action: {
      type: String,
      default: "",
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Trash2,
    Pencil,
    Eye,
  },
  data() {
    return {
      actions: [
        {
          id: "edit",
          tooltip: "Edit",
          icon: Pencil,
          classes: "hover:border-blue-50 hover:bg-blue-50 hover:text-info-100",
        },
        {
          id: "delete",
          tooltip: "Delete",
          icon: Trash2,
          classes: "hover:border-red-50 hover:bg-red-50 hover:text-danger-100",
        },
        {
          id: "view",
          tooltip: "View",
          icon: Eye,
          classes:
            "hover:border-primary-10 hover:bg-primary-10 hover:text-primary-100",
        },
      ],
    };
  },
  computed: {
    currentAction() {
      return this.actions.find((a) => a.id === this.action);
    },
  },
};
</script>
